export default function() {

	const $news_cat = $('.p-news__cat');
	const $panel_cat = $('.p-panel__cat');
	const $article_edtr_cat = $('.p-article-edtr__cat');

	$news_cat.each(function() {
		if($(this).text() == "イベント") {
			$(this).addClass('c-color-red');
		}else if($(this).text() == "トピックス") {
			$(this).addClass('c-color-blue');
		}else if($(this).text() == "おおいたん酒と旅") {
			$(this).addClass('c-color-green');
		}else if($(this).text() == "おおいたん酒と人") {
			$(this).addClass('c-color-orange');
		}else if($(this).text() == "イキな飲み方レシピ") {
			$(this).addClass('c-color-purple');
		}else if($(this).text() == "ジモティな肴レシピ") {
			$(this).addClass('c-color-brown');
		}
	})

	$panel_cat.each(function() {
		if($(this).text() == "イベント") {
			$(this).addClass('c-color-red');
		}else if($(this).text() == "トピックス") {
			$(this).addClass('c-color-blue');
		}else if($(this).text() == "おおいたん酒と旅") {
			$(this).addClass('c-color-green');
		}else if($(this).text() == "おおいたん酒と人") {
			$(this).addClass('c-color-orange');
		}else if($(this).text() == "イキな飲み方レシピ") {
			$(this).addClass('c-color-purple');
		}else if($(this).text() == "ジモティな肴レシピ") {
			$(this).addClass('c-color-brown');
		}
	})

	$article_edtr_cat.each(function() {
		if($(this).text() == "イベント") {
			$(this).addClass('c-color-red');
		}else if($(this).text() == "トピックス") {
			$(this).addClass('c-color-blue');
		}else if($(this).text() == "おおいたん酒と旅") {
			$(this).addClass('c-color-green');
		}else if($(this).text() == "おおいたん酒と人") {
			$(this).addClass('c-color-orange');
		}else if($(this).text() == "イキな飲み方レシピ") {
			$(this).addClass('c-color-purple');
		}else if($(this).text() == "ジモティな肴レシピ") {
			$(this).addClass('c-color-brown');
		}
	})

}
